"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse2001ToJSON = exports.InlineResponse2001FromJSONTyped = exports.InlineResponse2001FromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function InlineResponse2001FromJSON(json) {
    return InlineResponse2001FromJSONTyped(json, false);
}
exports.InlineResponse2001FromJSON = InlineResponse2001FromJSON;
function InlineResponse2001FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        'message': !(0, runtime_1.exists)(json, 'message') ? undefined : json['message'],
        'stats': !(0, runtime_1.exists)(json, 'stats') ? undefined : (0, _1.InlineResponse2001StatsFromJSON)(json['stats']),
        'startTime': !(0, runtime_1.exists)(json, 'startTime') ? undefined : json['startTime'],
    };
}
exports.InlineResponse2001FromJSONTyped = InlineResponse2001FromJSONTyped;
function InlineResponse2001ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'message': value.message,
        'stats': (0, _1.InlineResponse2001StatsToJSON)(value.stats),
        'startTime': value.startTime,
    };
}
exports.InlineResponse2001ToJSON = InlineResponse2001ToJSON;
